export const config = {
  enableMultiuser: false,
  autoSave: false,
  autoResolveConflicts: false,
};
